<template>
  <b-row>
    <b-row class="ml-1">
      <h3>Sumup-Auszahlungen</h3>
    </b-row>
    <b-row class="mb-2">
      <b-col
          md="2"
          sm="4"
          class="my-1"
      >

        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Per page</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          sm="4"
          class="my-1"
      >

        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Per page</label>
          <b-form-select
              v-model="voucherOption"
              size="sm"
              :options="voucherOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          sm="8"
          class="my-1"
      >
        <b-form-group
            label="Datum"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="sortBySelect"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                ref="fieldData"
                v-model="date.from"
                type="text"
                placeholder="DD.MM.YY"
                autocomplete="off"
                show-decade-nav
                @keypress="EnterDate($event)"
            />
            <b-input-group-append>
              <b-form-datepicker
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                  button-only
                  :start-weekday="1"
                  locale="de-DE"
                  color="danger"
                  size="sm"
                  @context="onDateFromContext"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          sm="8"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                ref="fieldData"
                v-model="date.to"
                type="text"
                placeholder="DD.MM.YY"
                autocomplete="off"
                show-decade-nav
                @keypress="EnterDate($event)"
            />
            <b-input-group-append>
              <b-form-datepicker
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                  button-only
                  :start-weekday="1"
                  locale="de-DE"
                  color="danger"
                  size="sm"
                  @context="onDateToContext"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Name, Telefon etc."
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          class="my-1"
      >
        <b-form-group
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-dropdown
                class="btn-block"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="info"
                text="Steuer Ordner erstellen"
                right
            >
              <b-dropdown-item
                  variant="info"
                  @click="CreatePdf"
              >Jetzt erstellen
              </b-dropdown-item>
              <b-dropdown-divider/>
            </b-dropdown>

          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-table
            striped
            hover
            responsive
            :items="items"
            :fields="fields"
            @filtered="onFiltered"
        >
          <template #cell(SevDeskAmount)="data">
            <b-badge
                :variant="data.item.SevDeskAmount > 0 ? 'success' : 'danger'"
                class="float-right mb-1 ml-1"
                style="width: 100%"
            >
              {{ FormatEuro(data.item.SevDeskAmount) }}
            </b-badge>
          </template>
          <template #cell(SevDeskCreate)="data">
            {{ formatDate(data.item.SevDeskCreate) }}
          </template>
          <template #cell(SevDeskStatus)="data">
            <b-spinner
                v-if="data.item.SevDeskStatus == 100"
                class="mr-1"
                type="grow"
                style="width: 1em; height: 1em"
            />
            <feather-icon
                v-if="data.item.SevDeskStatus == 300"
                icon="CheckIcon"
                size="18"
                class="cursor-pointer"
            />
            <feather-icon
                v-if="data.item.SevDeskStatus == 350"
                icon="CheckIcon"
                size="18"
                class="cursor-pointer"
                style="color: #1ab7ea"
            />
            <feather-icon
                v-if="data.item.SevDeskStatus == 400"
                icon="CheckIcon"
                size="18"
                class="cursor-pointer"
                style="color: greenyellow"
            />

          </template>
          <template #cell(VoucherCount)="data">
            <b-badge
                pill
                :variant="data.item.VoucherCount > 0 ? 'light-info' : 'light-danger'"
                class="mb-1 ml-1"
            >
              {{ data.item.VoucherCount }}
            </b-badge>
          </template>

          <template #cell(Price)="data">
            <b-badge
                variant="light-info"
            >{{ data.item.NetSum }}
            </b-badge>
          </template>
          <template #cell(Action)="data">
            <div
                v-if="data.item.HasBtn"
                @click="OpenPdf(data.item.Reference)"
            >
              <b-avatar
                  size="24"
                  badge
                  :src="require('@/assets/images/icons/pdf.png')"
                  class="badge-minimal"
                  :badge-variant="data.item.HasFile ? 'success' : 'danger'"
              />
            </div>
          </template>
        </b-table>
      </b-col>

      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>
  </b-row>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BAlert, VBTooltip, BFormDatepicker,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ConnectedVoucherBadge from '@/views/extras/ConnectedVoucherBadge.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ConnectedVoucherBadge,
    BTable,
    BAvatar,
    BAlert,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BFormDatepicker,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
    BSpinner
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      perPage: 50,
      pageOptions: [10, 25, 50, 100, 250, 500],
      voucherOption: 0,
      voucherOptions: [{
        text: 'Alle',
        value: 0
      },
        {
          text: 'Gebucht',
          value: 1
        },
        {
          text: 'Offen',
          value: 1
        },
        {
          text: 'Privat',
          value: 1
        }],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      date: {
        from: '',
        to: ''
      },
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'Reference',
          label: 'Referenz',
        },
        {
          key: 'Amount',
          label: 'Betrag',
        },
        {
          key: 'Fee',
          label: 'Gebühr',
        },
        {
          key: 'VoucherCount',
          label: 'Voucher',
        },
        {
          key: 'Action',
          label: '',
        },
      ],
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },

  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Sumup - Auszahlungen'
    })
    this.LoadList()
    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList()
        },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.voucherOption,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList(0)
          }, 550)
        },
    )
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {

    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },

    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          },
      )}`
    },
    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.from = ctx.activeFormatted
        this.LoadList()
      }
    },
    onDateToContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.to = ctx.activeFormatted
        this.value = ctx.activeFormatted
        this.LoadList()
      }
    },
    OpenPdf(file) {
      let url = `/sumup/combine/pdf/${file}`
      this.$http.get(url, { responseType: 'blob' })
          .then(resp => {
            if (resp.data.type === 'application/json') {
              resp.data.text()
                  .then(data => {
                    const jsonData = JSON.parse(data)

                    console.log(jsonData) // Überprüfe die umgewandelten JSON-Daten in der Konsole

                    if (jsonData.hasOwnProperty('success')) {
                      console.log('Erfolg: ', jsonData.success)
                    } else {
                      console.log('Kein Erfolgswert vorhanden.')
                    }

                    if (jsonData.hasOwnProperty('errors')) {

                      jsonData.errors.forEach(error => {
                        console.log('Fehler: ', error)

                        this.$toast({
                              component: ToastificationContent,
                              props: {
                                title: 'Fehler',
                                icon: 'CheckIcon',
                                text: error,
                                variant: 'danger',
                              },
                            },
                            {
                              timeout: 5000,
                            })
                      })

                    } else {
                      console.log('Fehler Liste nicht gefunden.')
                    }
                  })
            }
            if (resp.data.type === 'application/pdf') {
              window.open(URL.createObjectURL(resp.data))
            } else {
              // Handle andere Dateitypen oder Reaktionen hier
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadList() {
      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `sumup/payout/history?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url += `&filter=${this.filter}`
      }
      if (this.date.from != '') {
        const date = this.date.from.split('.')
        if (this.date.from.length == 8) {
          url += `&fromDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      }
      if (this.date.to != '') {
        const date = this.date.to.split('.')
        if (this.date.to.length == 8) {
          url += `&toDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      }
      this.$http.get(url)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            let feeTotal = 0
            let AmountTotal = 0
            let VoucherTotal = 0
            resp.data.list.forEach(i => {
              console.log(i)

              //let voucherCount = Object.values(i.InvoiceList).length + Object.values(i.SevDeskVoucherList).length
              AmountTotal += i.Amount
              feeTotal += i.Fee
              VoucherTotal += Object.values(i.TransactionList).length
              let item = {
                Reference: i.Reference,
                Amount: this.FormatEuro(i.Amount),
                Fee: this.FormatEuro(i.Fee),
                VoucherCount: Object.values(i.TransactionList).length,
                HasFile: false,
                HasBtn: true,
              }

              this.items.push(item)
            })
            let item = {
              Reference: 'Summe Auszahlungen',
              Amount: this.FormatEuro(AmountTotal),
              Fee: this.FormatEuro(feeTotal),
              VoucherCount: VoucherTotal,
              HasFile: false,
              HasBtn: false,
            }

            this.items.push(item)

          })
          .catch(err => {
            console.error(err)
          })
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
